import axios from './http';

export function getUser() {
  return axios.get('users/account');
}

export function getNotifications() {
  return axios.get('users/notifications');
}

export function getMetrics() {
  return axios.get('users/metrics');
}

export function getShareUrl(params) {
  return axios.get('users/share_url', { params })
}

export function logoutUser(url) {
  return axios.delete(url)
}
